module.exports = __webpack_public_path__ + "static/media/favicon.354c5fe6.ico";